__turbopack_context__.v({
  "underenhet": "Underenhet-module__gEBWHq__underenhet",
  "underenhetInnhold": "Underenhet-module__gEBWHq__underenhetInnhold",
  "underenhetTekst": "Underenhet-module__gEBWHq__underenhetTekst",
  "underenhetTittel": "Underenhet-module__gEBWHq__underenhetTittel",
  "underenhetValgtIkon": "Underenhet-module__gEBWHq__underenhetValgtIkon",
});
